import { render } from "./NewArrivals.vue?vue&type=template&id=5c498a11&scoped=true"
import script from "./NewArrivals.vue?vue&type=script&lang=js"
export * from "./NewArrivals.vue?vue&type=script&lang=js"

import "./NewArrivals.vue?vue&type=style&index=0&id=5c498a11&scoped=true&lang=css"
import "./NewArrivals.vue?vue&type=style&index=1&id=5c498a11&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c498a11"]])

export default __exports__